import React, { useCallback, useEffect, useState } from "react";
import { getProductImages } from "~/cores/productCore";
import * as styles from "./BigProductImage.module.scss";
import { getBrandProductImageAspectRatio, getBrandProductImageObjectFit } from "~/cores/brandDataCore";
import ImageCarousel from "rylak-common/src/image/ImageCarousel.jsx";
import { Tooltip } from "~/components/tooltip/Tooltip";

export default function BigProductImage(props) {
    const { appProps, product, selectedAlternative, swapToProduct, style } = props;

    const { getLocaleText } = appProps;

    const [showOriginal, setShowOriginal] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [productToShow, setProductToShow] = useState(product);

    const objectFit = getBrandProductImageObjectFit(appProps);
    const [aspectRatioX, aspectRatioY] = getBrandProductImageAspectRatio(appProps).split(":");

    const changeProductToShow = useCallback((product) => {
        setProductToShow(product);
        setCurrentImageIndex(0);
    }, []);

    const newVariantOrProduct = !!(selectedAlternative || swapToProduct);

    let images = getProductImages(productToShow);
    if (!images.length) {
        images = getProductImages(swapToProduct);
    }
    if (!images.length) {
        images = getProductImages(product);
    }

    useEffect(() => {
        const newProductToShow = selectedAlternative || swapToProduct || product;
        if (newProductToShow !== productToShow) {
            changeProductToShow(newProductToShow);
            if (showOriginal && (selectedAlternative || swapToProduct)) {
                setShowOriginal(false);
            }
            if (!showOriginal && !(selectedAlternative || swapToProduct)) {
                setShowOriginal(true);
            }
        }
    }, [productToShow, product, selectedAlternative, swapToProduct, changeProductToShow, showOriginal]);

    return (
        <>
            {newVariantOrProduct && (
                <BigProductImage
                    {...props}
                    selectedAlternative={null}
                    swapToProduct={null}
                    style={{
                        position: "absolute",
                        zIndex: 1,
                        visibility: showOriginal ? "visible" : "hidden",
                    }}
                />
            )}
            <div className={styles["image-container-outer"]} style={style}>
                <ImageCarousel
                    currentImageIndex={currentImageIndex}
                    setCurrentImageIndex={setCurrentImageIndex}
                    images={images}
                    objectFit={objectFit}
                    aspectRatioX={aspectRatioX}
                    aspectRatioY={aspectRatioY}
                    imageChildren={
                        <>
                            {newVariantOrProduct && (
                                <Tooltip tight style={{ zIndex: 2 }} content={getLocaleText("compare-tooltip")} className={styles["compare-btn-wrapper"]}>
                                    <button className={styles["compare-btn"]} onClick={() => setShowOriginal(!showOriginal)}>
                                        {getLocaleText("compare-btn")}
                                    </button>
                                </Tooltip>
                            )}
                            <div className={styles["returning"]}>{getLocaleText(newVariantOrProduct ? "getting" : "returning")}</div>
                        </>
                    }
                />
            </div>
        </>
    );
}
